module.exports = __webpack_public_path__ + "static/media/usa-anli7.a471b814.jpg";